import { SiteTagDomainMap } from 'providers/contexts/extensions/SiteTaxonomy';

type SiteTagItem = string | { name?: string; path?: string; [key: string]: unknown };

export const getSiteTagName = (item: SiteTagItem): string => {
  return typeof item === 'object' ? String(item?.name ?? item?.path ?? '') : String(item);
};

export const getSiteTagDomain = (
  siteTagName: string,
  siteTagDomainMap: SiteTagDomainMap,
): string | null => {
  if (!siteTagName) {
    return null;
  }

  return siteTagDomainMap[siteTagName]?.domain ?? null;
};

export const isOriginSiteTag = (
  siteTagDomain: string | null,
  originDomain: string | undefined,
): boolean => {
  return Boolean(siteTagDomain && originDomain && siteTagDomain === originDomain);
};
